'use client';

import React from 'react';
import { useLanguage } from '@/context/LanguageContext';

export default function ProcessSection() {
  const { t } = useLanguage();

  return (
    <section
      id="proces"
      className="py-24 px-6 bg-[#050507] relative overflow-hidden border-t border-white/5"
      aria-label="Procés de treball"
    >
      <div className="max-w-7xl mx-auto space-y-16 relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto space-y-4">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-gold/30 bg-gold/5 text-gold text-[11px] font-bold uppercase tracking-widest">
            {t.process.badge}
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white tracking-tight uppercase">
            {t.process.title}
          </h2>
          <p className="text-slate-300 text-sm sm:text-base leading-relaxed">
            {t.process.sub}
          </p>
        </div>

        {/* 4 Steps Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {t.process.steps.map((step, idx) => (
            <div
              key={idx}
              className="rounded-2xl p-7 bg-gradient-to-b from-[#111119] to-[#09090e] border border-white/10 hover:border-gold/40 transition-all duration-300 relative space-y-4 flex flex-col justify-between"
            >
              <div className="space-y-3">
                <span className="text-4xl font-black bg-gradient-to-r from-gold to-magenta-brand bg-clip-text text-transparent">
                  {step.num}
                </span>
                <h3 className="text-lg font-bold text-white leading-snug">
                  {step.title}
                </h3>
                <p className="text-xs sm:text-sm text-slate-300 leading-relaxed">
                  {step.desc}
                </p>
              </div>

              {idx < 3 && (
                <div className="hidden lg:block absolute -right-3 top-1/2 -translate-y-1/2 text-gold/40 font-black text-xl">
                  →
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
